import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

//generalised function to handle the tab changes
export const tabChange = (pageName: string) => {
  return new UFOExperience(`${pageName}`, {
    type: ExperienceTypes.Operation,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
  });
};
